import { render } from "./JobsMonitor.vue?vue&type=template&id=2e5628df&scoped=true&ts=true"
import script from "./JobsMonitor.vue?vue&type=script&lang=ts"
export * from "./JobsMonitor.vue?vue&type=script&lang=ts"

import "./JobsMonitor.vue?vue&type=style&index=0&id=2e5628df&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5628df"]])

export default __exports__